export const changeFocus = (id, value, expiryRef, cscRef) => {
  setTimeout(() => {
    if (id === 'cardNumber' && value.length > 0 && value.search('_') === -1) {
      expiryRef?.focus();
    } else if (id === 'cardExpiryDate' && value.length > 0 && value.search('_') === -1 && cscRef !== null) {
      cscRef?.focus();
    }
  }, 0);
};
